import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const InsertionAndSelectionSort = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Insertion Sort & Selection Sort"
    videos={[
      "https://www.youtube.com/embed/XHqN5OsCzGw",
      "https://www.youtube.com/embed/9oWd4VJOwr0"
    ]}
    takeaways={[
      { text: "Sometimes a question can be asked by giving the first few steps of the sorting technique and ask you to detect which sorting algorithm it is." },
      { text: "For every sorting algorithm, learn the implementation, algorithm, pseudocode, time complexities, number of comparisons required, and possible optimizations." }
    ]}
    questions={[
      "Analyze Insertion sort algorithm. Sort and give the trace for the following elements using Insertion sort.",
      "C, A, Z, S, P, S",
      "67, 65, 90, 83, 80, 83 (ASCII Values)"
    ]}
    exampleVideos={[]}
  />
);
}

export default InsertionAndSelectionSort;
